import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { avcTaskStatusRoute } from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/AvcTask'
import { avcTaskQueryKeys } from 'services/queryKeys'
import { RefetchIntervals } from 'types/query'

const StatusRaw = () => {
  const { t } = useTranslation()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { avcTaskId } = avcTaskStatusRoute.useParams()

  const avcTaskQuery = useQuery({
    ...avcTaskQueryKeys.detail({ taskId: avcTaskId }),
    refetchInterval: RefetchIntervals.FAST,
  })
  const { data: avcTask } = avcTaskQuery

  useEffect(() => {
    if (editorInstanceRef.current && avcTask) {
      editorInstanceRef.current.getModel()?.setValue(window.JSON.stringify(avcTask.status, null, 4))
    }
  }, [avcTask])

  if (avcTaskQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (!avcTask) {
    return <NotFound />
  }

  return (
    <Editor
      value={avcTask.status}
      readOnly
      readOnlyLabel={t('readOnlyAutoRefresh')}
      getEditorInstance={(editorInstance: EditorInstance) => void (editorInstanceRef.current = editorInstance)}
    />
  )
}

export const Status = memo(StatusRaw)
